import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConfigService } from '../../../core/services/config.service';
import { AppService } from '../../../core/services/app.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  public resetPasswordForm: FormGroup;
  public submitted = false;
  public isLoading = false;
  public loaderText = 'Réinitialisation en cours';
  public token: string;
  public matricule: string;
  public API_URL: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _http: HttpClient,
    private _loader: LoadingBarService,
    private toastrService: ToastrService,
    private title: Title,
    private configService: AppConfigService,
    private _service: AppService
  ) {
    this.API_URL = this.configService.get('HOST_API_ONLINE');
  }

  ngOnInit() {
    // Définir le titre de la page
    this.title.setTitle('Réinitialisation de mot de passe | HR Performance');
    
    // Initialiser le formulaire d'abord
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirm_password: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
    
    // Récupérer les paramètres de l'URL
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.matricule = params['matricule'];
      
      console.log('Token:', this.token);
      console.log('Matricule:', this.matricule);
      
      if (!this.token || !this.matricule) {
        this.toastrService.error('Lien de réinitialisation invalide');
        this.router.navigate(['/login']);
        return;
      }
      
      console.log('Paramètres valides, affichage du formulaire');
    });
  }

  // Validateur personnalisé pour vérifier que les mots de passe correspondent
  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password');
    const confirmPassword = form.get('confirm_password');
    
    if (password && confirmPassword && password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }
    
    if (confirmPassword && confirmPassword.errors && confirmPassword.errors['passwordMismatch']) {
      delete confirmPassword.errors['passwordMismatch'];
      if (Object.keys(confirmPassword.errors).length === 0) {
        confirmPassword.setErrors(null);
      }
    }
    
    return null;
  }

  get f() { return this.resetPasswordForm.controls; }

  getLogoPath(): string {
    const client = this.configService.get('SIGLE');
    if (client === 'SIR') {
      return 'assets/img/logo_SIR_transparent.png';
    } else if (client === 'SMB') {
      return 'assets/img/SMB/logo-icon.png';
    }
    return 'assets/img/logo_SIR_transparent.png'; // Default
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    this.submitted = true;
    
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.isLoading = true;
    this._loader.start();
    
    const payload = {
      matricule: this.matricule,
      password: this.resetPasswordForm.get('password').value,
      confirm_password: this.resetPasswordForm.get('confirm_password').value,
      token: this.token
    };

    this._http.post(`${this.API_URL}reset-password`, payload)
      .subscribe({
        next: (response: any) => {
          this._loader.stop();
          this.isLoading = false;
          if (response.error === false) {
            this.toastrService.success(response.message || 'Mot de passe réinitialisé avec succès');
            this.router.navigate(['/login']);
          } else {
            this.toastrService.error(response.message || 'Erreur lors de la réinitialisation');
          }
        },
        error: (error) => {
          this._loader.stop();
          this.isLoading = false;
          this.toastrService.error(error.error?.message || 'Erreur lors de la réinitialisation');
        }
      });
  }
}
